import { StripeCardElement } from "@stripe/stripe-js";
import { CardType } from "./utils";
import { subdomainTypes } from "../../context/availableSubdomains";

interface IGetCardType {
  status: "success" | "error";
  cardType?: CardType;
  errorCode?: string;
}

export const getCardType = async (
  stripe: any,
  elements: any,
  CardElement: any,
  appBranch: subdomainTypes | "",
): Promise<IGetCardType | null> => {
  if (!stripe || !elements) return null;

  const cardElement = elements.getElement(CardElement);

  const { error: paymentMethodError, paymentMethod } = await stripe.createPaymentMethod({
    card: cardElement as StripeCardElement,
    type: "card",
  });

  if (paymentMethodError) {
    const errorCode = paymentMethodError.code;
    const commonErrors = ["incomplete_number", "incomplete_expiry", "incomplete_cvc"];

    if (commonErrors.includes(errorCode)) return null;

    return {
      status: "error",
      errorCode,
    };
  }

  // Determine card type. For example, if you're based in New Zealand,
  // treat cards with country code 'NZ' as domestic.
  if (paymentMethod.card && paymentMethod.card.country) {
    const cardType =
      paymentMethod.card.country === appBranch.toUpperCase() ? "national" : "international";

    return {
      status: "success",
      cardType,
    };
  }

  return null;
};
